






import React, { useEffect } from 'react';


import python from "../../assets/tech/odoo.png"
import php from "../../assets/tech/drupal.png"
import node from "../../assets/tech/wordpress.png"
import AOS from 'aos';
import 'aos/dist/aos.css'; 
 const Ecom = (props) => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
     
    });
  }, []);
  return (
    <div id='about12345'>
      <div className='container'>
        <div className='row'>
        <h2>
              E-commerce platforms
</h2>
          <div className='col-xs-12 col-md-12'  >
            {' '}
         <div style={{ marginBottom:30, display: 'flex', flexWrap: 'wrap'  , justifyContent:'space-evenly' }}   >  
         
         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px'  }}>
       
         <img  style={{height:150 , width:150  }}  data-aos='fade-up' src={python} className='grayscale-img' alt='' />{' '}
<p style={{
    textAlign: 'center',
    padding: '5px 10px',
    fontSize: '0.8em',
    backgroundColor: '#e0e0e0', 
    borderRadius: '12px',
    fontWeight: 'bold', 
    marginTop: '10px'
  }}>ODOO </p>
</div> 
         
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px'  }}>
       
<img style={{height:150 , width:150 }}  data-aos='fade-up' src={php} className='img-responsive grayscale-img' alt='' />{' '}
       <p style={{
    textAlign: 'center',
    padding: '5px 10px',
    fontSize: '0.8em',
    backgroundColor: '#e0e0e0', 
    borderRadius: '12px',
    fontWeight: 'bold', 
    marginTop: '10px'
  }}>DRUPAL </p>
       </div>


       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px'  }}>
       
       <img style={{height:150 , width:150 }}  data-aos='fade-up' src={node} className='img-responsive grayscale-img' alt='' />{' '} 
       <p style={{
    textAlign: 'center',
    padding: '5px 10px',
    fontSize: '0.8em',
    backgroundColor: '#e0e0e0', 
    borderRadius: '12px',
    fontWeight: 'bold', 
    marginTop: '10px'
  }}>WORDPRESS </p>
       </div> 
            
          

            
            
             </div>
       
       
          </div>
          <div className='col-xs-12 col-md-'  data-aos='fade-up'>
            <div className='about-text'>

           
<p>Expertise in the design, development, integration, implementation & maintenance of e-commerce platforms to provide a seamless end-customer experience.






</p>
         
             
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default  Ecom